import { Button } from '@/components/button/Button'

export type ErrorCardProps = {
  /** Large status code (e.g. “404”) */
  code: string
  /** Error title to display */
  title: string
  /** Error message to display */
  message: string
  /** Filled primary button label */
  actionLabel: string
  /** Callback when the action button is clicked */
  onClick: () => void
}

export default function ErrorCard({ code, title, message, actionLabel, onClick }: ErrorCardProps) {
  return (
    <div className="flex w-full max-w-[751px] flex-col">
      <div className="flex flex-col items-center rounded-lg border border-brand-neutral-200 bg-white px-12 py-14">
        <div className="flex w-full flex-col items-center gap-9 text-center">
          <div className="flex w-full flex-col items-center gap-6">
            <p className="w-full font-rethink-sans text-5xl font-bold leading-[normal] tracking-[-0.32px] text-brand-700">{code}</p>
            <div className="flex w-full flex-col gap-5 text-center">
              <p className="w-full font-rethink-sans text-4xl font-semibold leading-10 tracking-normal text-brand-neutral-950">{title}</p>
              <p className="w-full text-xl font-normal leading-6 tracking-[-0.32px] text-brand-neutral-800">{message}</p>
            </div>
          </div>
          <Button type="button" variant="filled" color="primary" size="md" onClick={onClick}>
            {actionLabel}
          </Button>
        </div>
      </div>
    </div>
  )
}
